import { Button } from '@mui/material';
import React, { FC, useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf';
import pdfjsWorker from 'react-pdf/dist/esm/pdf.worker.entry'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ErrorBoundary from '../components/ErrorBoundary';
import { useMultipleLocalizedText } from '../contexts/Localization/localizationHooks';


pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker

interface OfferLetterPreviewProps {
    /**
     * url to the pdf resource
     */
     documentURL: string
     /**
      * The type of document: SIGNED, UNSIGNED
      */
    type?: string
}
export const OfferLetterPreview: FC<OfferLetterPreviewProps> = ({
    documentURL,
    type,
}) => {
    const [numPages, setNumPages] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);

    const handleLoadSuccess = ({ numPages }: { numPages: number }) => {
        setNumPages(numPages)
    }

    const handleLoadError = (e: any) => {
        console.log(e)
    }

    const handleSourceError = (e: any) => {
        console.log(e)
    }

    const {
        NATIVEESIGNOFFERLETTER,
        NATIVEESIGNDOWNLOADOFFERLETTER,
        NATIVEESIGNDOWNLOADOFFERLETTERFILENAME,
        NATIVEESIGNPAGEXOFY,
        ERROR_OFFERLETTERRENDER,
    } = useMultipleLocalizedText()

    const pageXOfY = (NATIVEESIGNPAGEXOFY || '')
        .replace(':pageNumber', String(pageNumber))
        .replace(':numPages', String(numPages))

    return (
        <div style={{ padding: '15px' }}>
            <h2>{NATIVEESIGNOFFERLETTER}</h2>
            <p>{pageXOfY}</p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button color="primary" disabled={pageNumber === 1} onClick={() => setPageNumber(pageNumber - 1)}>
                        <ArrowBackIosNewIcon />
                    </Button>
                    <ErrorBoundary text={ERROR_OFFERLETTERRENDER}>
                        <Document 
                            file={documentURL} 
                            onLoadSuccess={handleLoadSuccess} 
                            onLoadError={handleLoadError} 
                            onSourceError={handleSourceError}
                            options={{ isEvalSupported: false }}
                        >
                            <Page pageNumber={pageNumber} />
                        </Document>
                    </ErrorBoundary>
                    <Button color="primary" disabled={pageNumber >= numPages} onClick={() => setPageNumber(pageNumber + 1)}>
                        <ArrowForwardIosIcon />
                    </Button>
                </div>
            </div>
            <p>{pageXOfY}</p>
            <Button download={NATIVEESIGNDOWNLOADOFFERLETTERFILENAME} href={documentURL}>{NATIVEESIGNDOWNLOADOFFERLETTER}</Button>
        </div>
    )
}
export default OfferLetterPreview